// extracted by mini-css-extract-plugin
module.exports = {"enterEmailWrapper":"EnterNewPassword_enterEmailWrapper__1OpKV","subTitle":"EnterNewPassword_subTitle__wCoq8"};